import { VerificationCountsByLocationIdsResponse } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/v2/insurance_verification_adapter.pb';

export const aggregateVerificationCounts = (data: VerificationCountsByLocationIdsResponse | undefined) => {
  const result = {
    'Auto-Verified': 0,
    Error: 0,
    'Manual Verified': 0,
    Total: 0,
    Unverified: 0,
  };

  const locations = data?.locationVerificationCounts || {};

  Object.values(locations).forEach((location) => {
    const analysis = location?.verificationAnalysis || {};
    result['Auto-Verified'] += analysis['Auto-Verified'] || 0;
    result['Error'] += analysis['Error'] || 0;
    result['Manual Verified'] += analysis['Manual Verified'] || 0;
    result['Total'] += analysis['Total'] || 0;
    result['Unverified'] += analysis['Unverified'] || 0;
  });

  return result;
};
